import { EMAIL_CREATION_FORM_FIELD_NAME_TO } from '../../../EmailCreationForm.constants'

export function getAddedDocTemplate({ docTemplates, prevDocTemplates }) {
  return docTemplates.find(
    docTemplate => !prevDocTemplates.includes(docTemplate)
  )
}

export function hasFilledRecipients(values) {
  return values[EMAIL_CREATION_FORM_FIELD_NAME_TO].some(
    recipient => !!recipient?.value
  )
}
